import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {BLEND_MODES} from "pixi.js";
import {XW2GameMode, XwaysHoarder2} from "../XwaysHoarder2";
import {XwaysHoarder2Statics} from "../XwaysHoarder2Statics";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {XwaysHoarder2GameAssets} from "../XwaysHoarder2GameAssets";
import {XwaysHoarder2Sound} from "../sound/XwaysHoarder2Sound";

export class ScatterReelAnticipationView extends PIXI.Container {
    public islastReelActive: boolean = false;
    private _lightSpine: PIXI.spine.Spine[] = [];
    private _lastReelPlunderAnimation: TimelineSprite;
    private _lastReelPlunderAnimation2: TimelineSprite;
    private soundStarted: boolean = false;

    constructor() {
        super();
        this.name = "anticipationView";
        this.load();
        this.onResize();
    }

    public onResize(): void {
        if (NolimitApplication.isLandscape) {
            this.position.set(0, 0);
            this.scale.set(1, 1);
            this._lastReelPlunderAnimation.scale.set(1, 1);
            this._lastReelPlunderAnimation.position.set(762, 190);
            this._lastReelPlunderAnimation2.scale.set(1, -1);
            this._lastReelPlunderAnimation2.position.set(762, 566);
            this._lightSpine.forEach((item: PIXI.spine.Spine, index: number) => {
                item.position.set(XwaysHoarder2Statics.symbolWidth * (index + 1) - 40, 70);
            });

        } else {
            this.position.set(60, 90);
            this.scale.set(0.8, 0.8);
            this._lastReelPlunderAnimation.scale.set(0.9, 0.9);
            this._lastReelPlunderAnimation.position.set(754, 187);
            this._lastReelPlunderAnimation2.scale.set(0.9, -0.9);
            this._lastReelPlunderAnimation2.position.set(754, 545);
            this._lightSpine.forEach((item: PIXI.spine.Spine, index: number) => {
                item.position.set(150 * (index + 1), 77);
            });

        }
    }

    public startAnticipationOnNextReel(reelNo: number): void {
        if (reelNo > 0) {
            this._lightSpine[reelNo - 1].visible = true;
            this._lightSpine[reelNo - 1].state.setAnimation(0, "excitement", true);
            this._lightSpine[reelNo - 1].state.timeScale = 7;

            if (!this.soundStarted) {
                XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.SCATTER_ANTICIPATION);
                this.soundStarted = true;
            }
        }
    }

    public stopCurrentReelAnticipation(reelNo: number): void {
        if (reelNo > 0) {

            this._lightSpine[reelNo - 1].visible = false;
            this._lightSpine[reelNo - 1].state.setEmptyAnimation(0, 0);
        }

        if (reelNo === 5) {
            XwaysHoarder2Sound.stopSound(XwaysHoarder2Sound.SCATTER_ANTICIPATION);

            if (XwaysHoarder2.model.data.nextMode !== XW2GameMode.FREESPIN && XwaysHoarder2.model.data.nextMode !== XW2GameMode.SUPER_FREESPIN) {
                XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.SCATTER_ANTICIPATION_FAIL);
            }
            this.soundStarted = false;
        }

    }

    public playPlunderSpinAttention(): void {
        this._lastReelPlunderAnimation.visible = true;
        this._lastReelPlunderAnimation.show();
        this._lastReelPlunderAnimation.playLoop();
        this._lastReelPlunderAnimation2.visible = true;
        this._lastReelPlunderAnimation2.show();
        this._lastReelPlunderAnimation2.playLoop();
        this.islastReelActive = true;
    }

    public stopPlunderSpinAttention(): void {
        this._lastReelPlunderAnimation.stopLoop();
        this._lastReelPlunderAnimation.hide();
        this._lastReelPlunderAnimation2.stopLoop();
        this._lastReelPlunderAnimation2.hide();
        this.islastReelActive = false;
    }

    private load(): void {
        for (let reelId: number = 1; reelId <= 5; reelId++) {
            const anticipSpine: PIXI.spine.Spine = new PIXI.spine.Spine(XwaysHoarder2.assetLoader.getSpineAsset(XwaysHoarder2GameAssets.SCATTER_ANTICIPATION));
            // anticipSpine.state.setAnimation(0, "excitement", true);
            anticipSpine.name = `anticipSpine_reelNo${reelId}`;
            anticipSpine.visible = false;
            anticipSpine.position.set(XwaysHoarder2Statics.symbolWidth * reelId - 40, 90);
            this.addChild(anticipSpine);
            this._lightSpine.push(anticipSpine);
        }


        this._lastReelPlunderAnimation = new TimelineSprite(XwaysHoarder2.assetLoader.getTextures("SCReelAnticipation"));
        this._lastReelPlunderAnimation.visible = false;
        this._lastReelPlunderAnimation.hide();
        this._lastReelPlunderAnimation.blendMode = BLEND_MODES.SCREEN;
        this._lastReelPlunderAnimation.scale.set(1, 1);
        this._lastReelPlunderAnimation.anchor.set(0.5, 0.5);
        this._lastReelPlunderAnimation.name = "reelId_6_top";
        this._lastReelPlunderAnimation.position.set(XwaysHoarder2Statics.symbolWidth * 5 - 38, 192);

        this._lastReelPlunderAnimation2 = new TimelineSprite(XwaysHoarder2.assetLoader.getTextures("SCReelAnticipation"));
        this._lastReelPlunderAnimation2.hide();
        this._lastReelPlunderAnimation2.blendMode = BLEND_MODES.SCREEN;
        this._lastReelPlunderAnimation2.scale.set(1, -1);
        this._lastReelPlunderAnimation2.anchor.set(0.5, 0.5);
        this._lastReelPlunderAnimation2.name = "reelId_6_bottom";
        this._lastReelPlunderAnimation2.visible = false;
        this._lastReelPlunderAnimation2.position.set(XwaysHoarder2Statics.symbolWidth * 5 - 38, 536);
        this.addChild(this._lastReelPlunderAnimation);
        this.addChild(this._lastReelPlunderAnimation2);

    }
}